module.exports = __webpack_public_path__ + "img/fossil4Img4.a84af7fe.jpg";